/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

import Common   from "../Common";

/**
 * @class
 */
export default class BoomerangPreloaderScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {number}
         */
        this.loaded = 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._bar = null;

        /**
         * @member {PIXI.BitmapText}
         * @private
         */
        this._text = null;

        /**
         *
         * @member {PIXI.extras.MovieClip}
         * @private
         */
        this._logo = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const g = new PIXI.Graphics();
        g.clear();
        g.beginFill(0x872F87);
        g.drawRect(0, 0, Common.STAGE_WIDTH, Common.STAGE_HEIGHT);
        g.endFill();
        this.addChild(g);

        const holder = new PIXI.Container();
        holder.x = Common.STAGE_WIDTH * 0.5;
        holder.y = Common.STAGE_HEIGHT * 0.5 + 80;
        this.addChild(holder);

        const frames = [];
        for (let i = 1; i < 10; ++ i) {
            frames.push(assets.getTexture("loader_animation000" + i));
        }
        frames.push(assets.getTexture("loader_animation0010"));

        const sequence = new p3.MovieClipSequence();
        sequence.addTextures(frames);

        this._logo = new p3.MovieClip(sequence);
        this._logo.x = 50;
        this._logo.y = 20;
        this._logo.anchor = new PIXI.Point(0.5, 1);
        this._logo.animationSpeed = 1 / 4;
        this._logo.looping = false;
        holder.addChild(this._logo);

        this._bar = new PIXI.Sprite(assets.getTexture("preloader_bg"));
        this._bar.y = 34;
        this._bar.anchor = new PIXI.Point(0.5, 0.5);
        holder.addChild(this._bar);

        this._bar.fill = new PIXI.Sprite(assets.getTexture("preloader_bar"));
        this._bar.fill.anchor = new PIXI.Point(0.5, 0.5);
        this._bar.addChild(this._bar.fill);

        this._bar.fill.mask = new PIXI.Graphics();
        this._bar.fill.mask.x = -this._bar.fill.texture.width * 0.5;
        this._bar.fill.mask.scale.x = 0;
        this._bar.fill.mask.beginFill(0xFF0000);
        this._bar.fill.mask.drawRect(0, -this._bar.fill.texture.height * 0.5,
            this._bar.fill.texture.width, this._bar.fill.texture.height);
        this._bar.fill.addChild(this._bar.fill.mask);

        this._bar.frame = new PIXI.Sprite(assets.getTexture("preloader_overlay"));
        this._bar.frame.anchor = new PIXI.Point(0.5, 0.5);
        this._bar.addChild(this._bar.frame);

        this._text = new PIXI.Text("0%", {fontSize: "32px", fontFamily: "Arial", fill: "#FFFFFF", align: "center"});
        this._text.y = this._bar.y + 60;
        this._text.pivot.x = this._text.width * 0.5;
        this._text.pivot.y = this._text.height * 0.5;
        holder.addChild(this._text);

        // google font loader
        const text = new PIXI.Text("", {fontSize: "1px", fontFamily: "Noto Kufi Arabic"});
        text.visible = false;
        this.addChild(text);
    }

    appear() {
        super.appear();

        this._logo.play();
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;
        //this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;
    }

    update() {
        const loaded = Math.min(1, this.loaded);
        this._bar.fill.mask.scale.x += (loaded - this._bar.fill.mask.scale.x) * 0.4;

        this._text.text = "" + Math.round(loaded * 100) + "%";
        this._text.pivot.x = this._text.width * 0.5;
    }
}
